import React from 'react';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const PaginationNextIcon = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    return (
      <svg
        {...generateAttributes(attributes, classes)}
        height={px(12)}
        width={px(12)}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 12 12"
        transform="translate(0, 1)"
      >
        <path
          fill="none"
          stroke="currentColor"
          fillRule="evenodd"
          d="M4 2l4 4-4 4"
        />
      </svg>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Icon',
  className: 'w-pagination-next-icon',
  showEmpty: false,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Star')),
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginLeft: px(4),
        },
      },
    },
  },
  constraints: {
    ancestors: [
      {
        is: 'PaginationNext',
        rule: 'ExactlyOne',
      },
    ],
  },
  render: PaginationNextIcon,
  fields: {},
});

export default config;
